import { render, staticRenderFns } from "./ListaPaineisUnidade.vue?vue&type=template&id=1a1c76f8&scoped=true"
import script from "./ListaPaineisUnidade.vue?vue&type=script&lang=js"
export * from "./ListaPaineisUnidade.vue?vue&type=script&lang=js"
import style0 from "./ListaPaineisUnidade.vue?vue&type=style&index=0&id=1a1c76f8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a1c76f8",
  null
  
)

export default component.exports